<script>
import { mapState } from "vuex";

export default {
  locales: {
    pt: {
      'D': 'D',
      'H': 'H',
      'M': 'M',
      'S': 'S',
      'remaining': 'restantes',
    },
    es: {
      'D': 'D',
      'H': 'H',
      'M': 'M',
      'S': 'S',
      'remaining': 'restantes',
    }
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  watch: {
    // Após F5 o guard chama next() antes do GET user terminar; date chega depois no store
    'account.user.date'(val) {
      if (val) this.initStar72()
    },
  },
  data() {
    return {
      percent: 0,
      remaining: '',
      expired: false,
      timer: null,
      dateStart: '',
      dateEnd: '',
      remainingLabel: '',
      countdown: { days: 0, hours: 0, minutes: 0, seconds: 0 },
    };
  },
  methods: {
    initStar72() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.percent = 0;
      this.expired = true;
      this.dateStart = '';
      this.dateEnd = '';
      this.remaining = '';
      this.remainingLabel = '';
      this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };

      const dateAdded = this.account?.user?.package?.star1000?.date
      if (!dateAdded) return

      const deadline = new Date(dateAdded).getTime() + (72 * 60 * 60 * 1000)

      const formatDate = (ts) => {
        const d = new Date(ts)
        const dd = String(d.getDate()).padStart(2, '0')
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const yyyy = d.getFullYear()
        const hh = String(d.getHours()).padStart(2, '0')
        const mi = String(d.getMinutes()).padStart(2, '0')
        return `${dd}/${mm}/${yyyy}<br>${hh}:${mi}`
      }

      this.dateStart = formatDate(new Date(dateAdded).getTime())
      this.dateEnd = formatDate(deadline)

      const tick = () => {
        const now = Date.now()
        const elapsed = now - new Date(dateAdded).getTime()
        const total = 72 * 60 * 60 * 1000

        if (elapsed >= total) {
          this.percent = 100
          this.expired = true
          clearInterval(this.timer)
          return
        } else {
          this.expired = false;
        }

        this.percent = Math.min((elapsed / total) * 100, 100)

        const remaining = deadline - now
        const totalHours = Math.floor(remaining / (1000 * 60 * 60))
        const days = Math.floor(totalHours / 24)
        const hours = totalHours % 24
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000)

        this.remaining = `${String(totalHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        this.countdown = { days, hours, minutes, seconds }
        this.remainingLabel = this.t('remaining')
      }

      tick()
      this.timer = setInterval(tick, 1000)
    },
  },
  mounted() {
    this.initStar72()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
};
</script>

<template>
  <fieldset v-if="!expired && account?.user?.package?.star1000?.status == 'yes'">
    <legend>STAR1000 72h</legend>
    <b-progress style="border-radius: 3px;" :value="Number(percent)" variant="default" height="15px"></b-progress>
    <div class="d-flex justify-content-between align-items-center mt-2">
      <small class="text-muted notranslate mt-1" v-html="dateStart" style="line-height: 14px;"></small>
      <div class="d-flex star72-countdown">
        <div v-if="countdown.days > 0" class="star72-box">
          <span class="star72-num">{{ countdown.days }}</span>
          <span class="star72-label">{{ t('D') }}</span>
        </div>
        <div v-if="countdown.hours > 0" class="star72-box">
          <span class="star72-num">{{ String(countdown.hours).padStart(2, '0') }}</span>
          <span class="star72-label">{{ t('H') }}</span>
        </div>
        <div class="star72-box">
          <span class="star72-num">{{ String(countdown.minutes).padStart(2, '0') }}</span>
          <span class="star72-label">{{ t('M') }}</span>
        </div>
        <div class="star72-box">
          <span class="star72-num">{{ String(countdown.seconds).padStart(2, '0') }}</span>
          <span class="star72-label">{{ t('S') }}</span>
        </div>
      </div>
      <small class="text-muted text-right notranslate mt-1" v-html="dateEnd" style="line-height: 14px;"></small>
    </div>
  </fieldset>
</template>

<style scoped>
.star72-countdown {
  gap: 6px;
}
.star72-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F2F2F7;
  border-radius: 8px;
  padding: 8px 8px 3px;
  min-width: 38px;
}
.star72-num {
  font-size: 16px;
  font-weight: 700;
  line-height: .7;
  letter-spacing: -.01em;
}
.star72-label {
  font-size: 10px;
  font-weight: 600;
  color: #6E6E73;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
